import moment from 'moment';
import { forEach } from 'lodash';

class UtilityService {
  
  getDayList() {
      let dates = [];
      for (let i = 1; i<=31; i++) {
        dates.push(i);
      }
      return dates;
  }

  getListOfMonths() {
      let monthCollection = [];
      const months = moment.months();
      forEach(months, (eachMonth) => {
        monthCollection.push({key: moment().month(eachMonth).format("MM"), value: eachMonth})
      })
      return monthCollection;
  }

  getListOfYears() {
      const back = 100;
      const year = new Date().getFullYear() - 6;
      return Array.from({length: back}, (v, i) => year - back + i + 1).sort((a, b) => {
        return b - a;
      });
  }

  convertUTCDateTimetoLocalDateTime(dateString) {
    // Given UTC datetime string
    let utcDateTimeString = dateString
    // Convert the UTC datetime to local time using Moment.js
    let localDateTime = moment.utc(utcDateTimeString).local();
    return localDateTime;
  }
}

const instance = new UtilityService();
Object.freeze(instance);

export default instance;